module.exports = __webpack_public_path__ + "fe5be795c0bd3a6c99a452c3e3018390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/key-generic.png
// module id = 841
// module chunks = 0